module.exports = __webpack_public_path__ + "media/images/b2b_admin/login-2f3967ee253a050ad6b1cd14f3b3e108.png";